<template>
  <v-layout wrap>
    <v-flex xs12 md6>
      <v-autocomplete
        multiple box clearable
        items="autocompleteItems" :disabled="readonly"
        v-model="selection"
        label="Select field multiple label"
        no-data-text="No results"
        append-icon="keyboard_arrow_down"
        clear-icon="cancel">
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'multi-select-field',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    autocompleteItems: ["Foo", "Bar", "Fizz", "Buzz"],
    items() {
      let opts = []
      if (this.field) { if (this.field.options) { opts = this.field.options } }
      return opts
    },
    selection: {
      get() {
        if (this.data) {
          return this.data
        } else {
          if (this.field && this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(value) {
        this.$emit('update-item', { field: this.field.name, data: value, row: this.row })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  }
}
</script>
